const UTILS = (() => {
  var methods = {};

  methods.getCart = async () => {
    return await fetch("/cart.js").then((res) => res.json());
  };

  methods.refreshCart = () => {
    if (document.body.classList.contains("template-cart")) {
      window.location.reload();
    } else {
      document.dispatchEvent(
        new CustomEvent("ajaxProduct:added", { bubbles: true })
      );
    }
  };

  methods.addItemToCart = async (p_options) => {
    var itemsToAdd = {
      quantity: p_options.quantity,
      id: p_options.variant_id,
      selling_plan: p_options.selling_plan,
    };

    if (p_options.properties !== undefined) {
      itemsToAdd["properties"] = p_options.properties;
    }

    return await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: [itemsToAdd] }),
    });
  };

  // Kept as a public helper even though nothing in this file calls it any more
  // (see the removeGiftItemFromCart note in the Alpine component below). UTILS
  // is a global the rest of the theme can reach, so removing a method from it
  // is a different, riskier kind of change than removing a private function.
  methods.removeItemFromCart = async (itemToRemove) => {
    let req = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(itemToRemove),
    });
    return req;
  };

  methods.formatMoney = (value) => {
    return theme.Currency.formatMoney(value);
  };

  return methods;
})();

document.addEventListener(
  "click",
  function (event) {
    // If the clicked element doesn't have the right selector, bail
    if (!event.target.matches(".faq-article .title")) return;

    // Don't follow the link
    event.preventDefault();
    event.target.closest(".faq-article").classList.toggle("open");
  },
  false
);
document.addEventListener(
  "DOMContentLoaded",
  function () {
    // hand hugs added for truncated produc description
    let read_more = document.getElementById("read-more");
    let read_less = document.getElementById("read-less");
    let truncated_description = document.getElementById(
      "truncated-product-description"
    );
    let full_description = document.getElementById("product-description");
    // FIX (Sept 2026): both listeners used to be attached inside a single
    // `read_more` null check, so on any page that renders the "read more"
    // trigger without a matching "read less" one, the second line threw
    // "Cannot read properties of null" and aborted the rest of this
    // DOMContentLoaded handler. Each element is now guarded on its own.
    if (read_more) {
      read_more.addEventListener("click", showHideDescription);
    }
    if (read_less) {
      read_less.addEventListener("click", showHideDescription);
    }
    function showHideDescription() {
      let ID = this.id;
      if (ID === "read-more") {
        truncated_description.style.display = "none";
        full_description.style.display = "block";
      } else {
        truncated_description.style.display = "block";
        full_description.style.display = "none";
      }
    }
  },
  false
);

document.addEventListener("alpine:init", () => {
  Alpine.data("CartShipUpsells", () => ({
    threshold: {
      freegift: 0,
      freeship: 0,
    },
    data: {
      freegift_handle: "nossa-trucker",
      remaining: {
        freeship: 0,
        freegift: 0,
      },
      progress: {
        freeship: 0,
        freegift: 0,
      },
      flags: {
        freeship: false,
        freegift: false,
        freegiftAdded: false,
        cart_subscriptions: false,
        subs_free_ship: false,
      },
      cart: null,
    },
    init() {
      let am = this;
      (async () => {
        let cart = await UTILS.getCart();
        am.data.cart = cart;
        am.checkEligibility();
      })();

      document.addEventListener("cart-updated", async (e) => {
        let cart = await UTILS.getCart();
        am.data.cart = cart;
        am.checkEligibility();
      });
    },
    setThresholdSettings(p_options) {
      let am = this;
      am.threshold[p_options.key] = p_options.value;
      am.data.remaining[p_options.key] = p_options.value;
    },
    setFreegiftHandle(handle) {
      let am = this;
      am.data.freegift_handle = handle;
    },
    getCartTotal() {
      let am = this;
      return am.data.cart ? am.data.cart.total_price : 0;
    },
    getGiftItemInCart() {
      let am = this;
      let gift_item = am.data.cart.items.find((item) => {
        return item.handle == am.data.freegift_handle ? item : null;
      });
      return gift_item;
    },
    formatMoney(value) {
      return theme.Currency.formatMoney(value);
    },
    checkEligibility() {
      let am = this,
        freeship = false,
        freegift = false,
        freesubs = false;

      let remaining_freeship = am.threshold.freeship - am.getCartTotal();
      freeship = remaining_freeship <= 0;
      am.data.remaining.freeship =
        remaining_freeship < 0 ? 0 : remaining_freeship;
      am.data.flags.freeship = freeship;
      am.data.progress.freeship =
        (
          ((am.threshold.freeship - remaining_freeship) /
            am.threshold.freeship) *
          100
        ).toFixed(2) + "%";

      let remaining_freegift = am.threshold.freegift - am.getCartTotal();
      freegift = remaining_freegift <= 0;
      am.data.remaining.freegift = remaining_freegift;
      am.data.flags.freegift = freegift;
      am.data.flags.freegiftAdded = am.getGiftItemInCart();
      am.data.progress.freegift =
        (
          ((am.threshold.freegift - remaining_freegift) /
            am.threshold.freegift) *
          100
        ).toFixed(2) + "%";

      // other conditions
      let cart_subscriptions = !!am.data.cart.items.find(
        (item) => !!item.selling_plan_allocation
      );
      am.data.flags.cart_subscriptions = cart_subscriptions;
// get Total price for subscription product only 	
	let subscriptionTotal = am.data.cart.items
  .filter(item => !!item.selling_plan_allocation)
  .reduce((total, item) => total + item.final_line_price, 0);
 // Remaining price compare with subscriptionTotal 
	let remaining_subs = am.threshold.freeship - subscriptionTotal;
    freesubs = remaining_subs <= 0;
	// Return the true, false for subs_free_ship
  am.data.flags.subs_free_ship = cart_subscriptions && freesubs;
      setTimeout(() => {
        let $bar = document.querySelectorAll(".cart-upsell .bar");
        if ($bar) {
          for (let i = 0; i < $bar.length; ++i) {
            $bar[i].style.setProperty(
              "--fg_progress",
              am.data.progress.freegift
            );
          }
        }

        let $freeshipBar = document.querySelector(".cart-freeship .bar");
        if ($freeshipBar) {
          $freeshipBar.style.setProperty(
            "--fg_progress",
            am.data.progress.freeship
          );
        }
      }, 0);
    },
    addGiftItemToCart(e) {
      (async () => {
        let variant_id = e.target.dataset.variant_id;
        let variantToAdd = {
          variant_id: variant_id,
          quantity: 1,
          properties: {
            "__gift-upsell": "true",
          },
        };

        let res = await UTILS.addItemToCart(variantToAdd);
        if (res.ok) {
          UTILS.refreshCart();
        }
      })();
    },
    // Sept 2026: removeGiftItemFromCart() removed. It was an Alpine method on
    // this component, and this component is instantiated exactly once, by
    // x-data="CartShipUpsells" in snippets/cart.ship-progress-upsells.liquid
    // (rendered only from snippets/cart-drawer.liquid), so the only things
    // that could ever call it were that snippet's own bindings and this file.
    // Neither did: the snippet's only handler is addGiftItemToCart($event),
    // and both of this file's former callers were removed in earlier rounds.
    // To restore it, re-add a method that calls getGiftItemInCart() and passes
    // { id: gift_item.key, quantity: 0 } to UTILS.removeItemFromCart(), which
    // is still present above.
  }));
});


// CRO fix v2: Quick Buy button rework (Aug 2026). Previous version instantly
// added the first available variant to the cart. Per feedback, this now opens
// a dialog so the shopper can pick size, grind, quantity, and purchase
// frequency (one-time vs. ReCharge subscription) before anything is added.
// Reuses the same UTILS ajax-cart helpers as the rest of this file.
//
// See assets/custom.css for the CSS side, including the Sept 2026 fix to
// `.quick-product__btn { position }` - it was `static`, which silently
// disabled the button's own z-index and let Impulse's full-card
// `.grid-product__link::after` overlay sit on top of it, so on desktop the
// click landed on the card link and navigated to the product page instead of
// reaching the handler below.
//
// SUBSCRIPTION SAVINGS (Sept 2026, Round 11). The discount used to be visible
// only inside the "Purchase type" <select> option labels. On mobile that is a
// native full-screen picker, so a shopper saw a plain price and no indication
// that subscribing saved anything unless they happened to open the dropdown.
// Three changes, all driven from update() so they stay correct as the shopper
// switches variant or quantity:
//   1. option labels now carry real prices - "Delivery every 2 weeks - $16.00
//      (save $4.00)" - so the comparison is concrete inside the picker itself;
//   2. .nqb-save-note, a pill shown before any choice is made, naming the best
//      available discount for the selected variant;
//   3. .nqb-save, an explicit "You save $X.XX (N%)" line under the price once a
//      plan is chosen, alongside the existing struck-through original.
(function () {
  var overlayEl = null;
  var prevBodyOverflow = "";

  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
      return window.theme.Currency.formatMoney(cents, window.theme.settings ? window.theme.settings.moneyFormat : undefined);
    }
    return "$" + (cents / 100).toFixed(2);
  }

  function onKeydown(e) {
    if (e.key === "Escape") closeDialog();
  }

  function closeDialog() {
    if (!overlayEl) return;
    overlayEl.remove();
    overlayEl = null;
    document.removeEventListener("keydown", onKeydown);
    document.body.style.overflow = prevBodyOverflow;
  }

  function findVariant(product, selections) {
    return product.variants.find(function (v) {
      return product.options.every(function (opt, i) {
        var key = "option" + (i + 1);
        return v[key] === selections[i];
      });
    });
  }

  function buildDialog(product) {
    var state = {
      selections: product.options.map(function (opt) { return opt.values[0]; }),
      quantity: 1,
      sellingPlanId: null, // null = one-time purchase
    };

    overlayEl = document.createElement("div");
    overlayEl.className = "nqb-overlay";

    var modal = document.createElement("div");
    modal.className = "nqb-modal";
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");
    modal.setAttribute("aria-label", product.title);

    var closeBtn = document.createElement("button");
    closeBtn.type = "button";
    closeBtn.className = "nqb-modal__close";
    closeBtn.setAttribute("aria-label", "Close");
    closeBtn.innerHTML = "&times;";
    closeBtn.addEventListener("click", closeDialog);
    modal.appendChild(closeBtn);

    var header = document.createElement("div");
    header.className = "nqb-modal__header";
    if (product.images && product.images[0]) {
      var img = document.createElement("img");
      img.className = "nqb-modal__image";
      img.src = product.images[0];
      img.alt = product.title;
      header.appendChild(img);
    }
    var title = document.createElement("h3");
    title.className = "nqb-modal__title";
    title.textContent = product.title;
    header.appendChild(title);
    modal.appendChild(header);

    // Shown at rest, before the shopper has chosen anything. Populated in
    // update() because the best available discount depends on the variant.
    var saveNote = document.createElement("div");
    saveNote.className = "nqb-save-note";
    saveNote.hidden = true;
    modal.appendChild(saveNote);

    product.options.forEach(function (opt, i) {
      var field = document.createElement("div");
      field.className = "nqb-field";
      var label = document.createElement("label");
      label.className = "nqb-field__label";
      label.textContent = opt.name;
      var select = document.createElement("select");
      opt.values.forEach(function (val) {
        var o = document.createElement("option");
        o.value = val;
        o.textContent = val;
        if (val === state.selections[i]) o.selected = true;
        select.appendChild(o);
      });
      select.addEventListener("change", function () {
        state.selections[i] = select.value;
        update();
      });
      field.appendChild(label);
      field.appendChild(select);
      modal.appendChild(field);
    });

    var qtyField = document.createElement("div");
    qtyField.className = "nqb-field";
    var qtyLabel = document.createElement("label");
    qtyLabel.className = "nqb-field__label";
    qtyLabel.textContent = "Quantity";
    var qtyWrap = document.createElement("div");
    qtyWrap.className = "nqb-qty";
    var minusBtn = document.createElement("button");
    minusBtn.type = "button";
    minusBtn.setAttribute("aria-label", "Decrease quantity");
    minusBtn.textContent = "−";
    var qtyInput = document.createElement("input");
    qtyInput.type = "number";
    qtyInput.min = "1";
    qtyInput.value = "1";
    var plusBtn = document.createElement("button");
    plusBtn.type = "button";
    plusBtn.setAttribute("aria-label", "Increase quantity");
    plusBtn.textContent = "+";
    minusBtn.addEventListener("click", function () {
      state.quantity = Math.max(1, state.quantity - 1);
      qtyInput.value = state.quantity;
      update();
    });
    plusBtn.addEventListener("click", function () {
      state.quantity = state.quantity + 1;
      qtyInput.value = state.quantity;
      update();
    });
    qtyInput.addEventListener("change", function () {
      var n = parseInt(qtyInput.value, 10);
      state.quantity = (!n || n < 1) ? 1 : n;
      qtyInput.value = state.quantity;
      update();
    });
    qtyWrap.appendChild(minusBtn);
    qtyWrap.appendChild(qtyInput);
    qtyWrap.appendChild(plusBtn);
    qtyField.appendChild(qtyLabel);
    qtyField.appendChild(qtyWrap);
    modal.appendChild(qtyField);

    var freqSelect = null;
    if (product.selling_plan_groups && product.selling_plan_groups.length) {
      var freqField = document.createElement("div");
      freqField.className = "nqb-field";
      var freqLabel = document.createElement("label");
      freqLabel.className = "nqb-field__label";
      freqLabel.textContent = "Purchase type";
      freqSelect = document.createElement("select");
      var oneTimeOpt = document.createElement("option");
      oneTimeOpt.value = "";
      oneTimeOpt.textContent = "One-time purchase";
      freqSelect.appendChild(oneTimeOpt);
      product.selling_plan_groups.forEach(function (group) {
        group.selling_plans.forEach(function (plan) {
          var o = document.createElement("option");
          o.value = plan.id;
          // The visible label is rebuilt in update() so it can quote the real
          // price for whichever variant is currently selected. The plan name is
          // stashed here so that rebuild doesn't have to re-walk the groups.
          o.dataset.planName = plan.name;
          o.textContent = plan.name;
          freqSelect.appendChild(o);
        });
      });
      freqSelect.addEventListener("change", function () {
        state.sellingPlanId = freqSelect.value ? parseInt(freqSelect.value, 10) : null;
        update();
      });
      freqField.appendChild(freqLabel);
      freqField.appendChild(freqSelect);
      modal.appendChild(freqField);
    }

    var priceEl = document.createElement("div");
    priceEl.className = "nqb-price";
    modal.appendChild(priceEl);

    var saveEl = document.createElement("div");
    saveEl.className = "nqb-save";
    saveEl.hidden = true;
    modal.appendChild(saveEl);

    var statusEl = document.createElement("div");
    statusEl.className = "nqb-status";
    modal.appendChild(statusEl);

    var submitBtn = document.createElement("button");
    submitBtn.type = "button";
    submitBtn.className = "nqb-submit";
    submitBtn.textContent = "Add to cart";
    submitBtn.addEventListener("click", submit);
    modal.appendChild(submitBtn);

    function currentVariant() {
      return findVariant(product, state.selections);
    }

    function allocationsFor(variant) {
      return (variant && variant.selling_plan_allocations) || [];
    }

    // Rewrites every option label to quote the real price for the current
    // variant, e.g. "Delivery every 2 weeks - $16.00 (save $4.00)". This is the
    // change that matters most on mobile, where the <select> is a native
    // full-screen picker and is the only place the choice actually gets made.
    function refreshPlanLabels(variant) {
      if (!freqSelect || !variant) return;
      var allocs = allocationsFor(variant);
      Array.prototype.forEach.call(freqSelect.options, function (o) {
        if (!o.value) {
          o.textContent = "One-time purchase — " + formatMoney(variant.price);
          return;
        }
        var planId = parseInt(o.value, 10);
        var alloc = allocs.find(function (a) { return a.selling_plan_id === planId; });
        var name = o.dataset.planName || "Subscribe";
        if (alloc) {
          var diff = variant.price - alloc.price;
          o.textContent = name + " — " + formatMoney(alloc.price) +
            (diff > 0 ? " (save " + formatMoney(diff) + ")" : "");
        } else {
          o.textContent = name;
        }
      });
    }

    // The at-rest pill: names the best discount available on this variant, so
    // the shopper can see there is one without opening the picker. Hidden once
    // a plan is actually chosen, because at that point the price row and the
    // "You save" line below it are saying the same thing more precisely.
    function refreshSaveNote(variant) {
      if (!variant) { saveNote.hidden = true; return; }
      var best = null;
      allocationsFor(variant).forEach(function (a) {
        if (a.price < variant.price && (!best || a.price < best.price)) best = a;
      });
      if (!best || state.sellingPlanId) { saveNote.hidden = true; return; }

      var pct = Math.round(((variant.price - best.price) / variant.price) * 100);
      saveNote.textContent = "";
      var icon = document.createElement("span");
      icon.className = "nqb-save-note__icon";
      icon.setAttribute("aria-hidden", "true");
      icon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>';
      var text = document.createElement("span");
      text.appendChild(document.createTextNode("Subscribe & save "));
      var strong = document.createElement("strong");
      strong.textContent = pct + "%";
      text.appendChild(strong);
      text.appendChild(document.createTextNode(" — from " + formatMoney(best.price) + " per delivery"));
      saveNote.appendChild(icon);
      saveNote.appendChild(text);
      saveNote.hidden = false;
    }

    function update() {
      var variant = currentVariant();
      refreshPlanLabels(variant);
      refreshSaveNote(variant);

      if (!variant) {
        priceEl.textContent = "";
        saveEl.hidden = true;
        statusEl.textContent = "That combination is not available.";
        submitBtn.disabled = true;
        return;
      }
      if (!variant.available) {
        statusEl.textContent = "Sold out.";
        submitBtn.disabled = true;
      } else {
        statusEl.textContent = "";
        submitBtn.disabled = false;
      }
      var unitPrice = variant.price;
      var comparePrice = null;
      if (state.sellingPlanId && variant.selling_plan_allocations) {
        var alloc = variant.selling_plan_allocations.find(function (a) {
          return a.selling_plan_id === state.sellingPlanId;
        });
        if (alloc) {
          comparePrice = unitPrice;
          unitPrice = alloc.price;
        }
      }
      var total = unitPrice * state.quantity;

      priceEl.textContent = "";
      if (comparePrice) {
        var was = document.createElement("span");
        was.className = "nqb-price__compare";
        was.textContent = formatMoney(comparePrice * state.quantity);
        priceEl.appendChild(was);
      }
      priceEl.appendChild(document.createTextNode(formatMoney(total)));

      if (comparePrice && comparePrice > unitPrice) {
        var savedTotal = (comparePrice - unitPrice) * state.quantity;
        var savedPct = Math.round(((comparePrice - unitPrice) / comparePrice) * 100);
        saveEl.textContent = "You save " + formatMoney(savedTotal) + " (" + savedPct + "%)";
        saveEl.hidden = false;
      } else {
        saveEl.hidden = true;
      }
    }

    function submit() {
      var variant = currentVariant();
      if (!variant || !variant.available) return;
      submitBtn.disabled = true;
      submitBtn.textContent = "Adding...";
      statusEl.textContent = "";
      UTILS.addItemToCart({
        quantity: state.quantity,
        variant_id: variant.id,
        selling_plan: state.sellingPlanId,
      })
        .then(function (res) {
          if (res && res.ok) {
            UTILS.refreshCart();
            closeDialog();
          } else if (res) {
            return res.json().then(function (data) {
              throw new Error((data && data.description) || "Could not add to cart.");
            });
          }
        })
        .catch(function (err) {
          statusEl.textContent = (err && err.message) || "Something went wrong. Please try again.";
          submitBtn.disabled = false;
          submitBtn.textContent = "Add to cart";
        });
    }

    update();

    overlayEl.appendChild(modal);
    overlayEl.addEventListener("click", function (e) {
      if (e.target === overlayEl) closeDialog();
    });
    document.body.appendChild(overlayEl);
    prevBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKeydown);
    closeBtn.focus();
  }

  function openQuickBuy(btn) {
    var gridItem = btn.closest("[data-product-handle]");
    var handle = gridItem ? gridItem.getAttribute("data-product-handle") : null;
    if (!handle) return;

    var restingText = btn.dataset.quickBuyLabel || btn.textContent;
    btn.dataset.quickAddLoading = "true";
    btn.textContent = "Loading...";

    fetch("/products/" + handle + ".js")
      .then(function (res) { return res.json(); })
      .then(function (product) {
        btn.dataset.quickAddLoading = "false";
        btn.textContent = restingText;
        buildDialog(product);
      })
      .catch(function () {
        btn.dataset.quickAddLoading = "false";
        btn.textContent = "Error";
        setTimeout(function () {
          btn.textContent = restingText;
        }, 1500);
      });
  }

  // Captures the button's rendered text (which comes from the theme's own
  // "Quick shop text" setting, editable in the theme editor) once per button,
  // instead of overwriting it — so a merchant changing that setting in the
  // theme editor takes effect here too, and the resting label is correctly
  // restored after the button shows "Loading..." / "Error" states.
  function relabelQuickBuyButtons() {
    document.querySelectorAll(".quick-product__btn").forEach(function (btn) {
      if (btn.dataset.quickAddLoading !== "true" && !btn.dataset.quickBuyLabel) {
        btn.dataset.quickBuyLabel = btn.textContent.trim();
      }
    });
  }

  document.addEventListener("DOMContentLoaded", relabelQuickBuyButtons);

  // The button lives inside the theme's whole-card <a class="grid-product__link">.
  // A plain click-phase listener on document isn't early enough: this theme (or one
  // of its installed apps) also reacts to mousedown/pointerdown on card links to
  // kick off navigation before our click handler ever runs, so preventDefault() on
  // "click" alone doesn't stop it. Registering on window (the outermost point in the
  // capture phase, guaranteed to run before any document-level listener regardless
  // of script load order) for every stage of the click gesture — pointerdown,
  // mousedown, click — closes that gap.
  //
  // NOTE: this only ever fires if the click actually reaches the button. Until the
  // Sept 2026 CSS fix it did not on desktop - see the comment at the top of this
  // block, and the long note on `.quick-product__btn { position }` in custom.css.
  ["pointerdown", "mousedown", "click"].forEach(function (type) {
    window.addEventListener(
      type,
      function (event) {
        var btn = event.target.closest && event.target.closest(".quick-product__btn");
        if (!btn) return;

        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();

        if (type !== "click") return;
        if (btn.dataset.quickAddLoading === "true") return;
        if (overlayEl) return;

        openQuickBuy(btn);
      },
      true
    );
  });
})();

// CRO fix (Aug 2026): sequence our cart drawer behind ReCharge's post-add
// "Subscribe & Save" upsell offer.
//
// When a shopper adds an item as a one-time purchase that also has a
// subscription option, the ReCharge "Storefront Experiences" app shows its
// own offer overlay (asking them to switch to a subscription) right after
// the add. Our own cart drawer was opening at the same time and visually
// covering that offer. Geoff asked for the drawer to wait until the
// ReCharge offer is dismissed - via its "x", "Subscribe", or "Continue to
// cart" actions - and only then fly out as normal.
//
// ReCharge renders the offer inside a SHADOW ROOT attached to the light-DOM
// element #recharge-storefront-experiences__cart-overlay (also checked on
// its sibling -cart-drawer, in case which host it appears under ever
// varies), as a child element with id="cart-overlay-drawer". That element's
// presence in the shadow root means the offer is showing; ReCharge removes
// it from the DOM entirely - not just hides it - once it's dismissed via
// any of its three dismiss paths. Presence/absence is therefore a clean,
// directly-observed signal with no attribute parsing or content-height
// heuristics needed. Confirmed live in DevTools.
//
// Mechanism (sequenceOpen): when our drawer wants to open, first check the
// shadow DOM. If the offer is already showing, hold the drawer and watch
// the shadow root (MutationObserver, childList+subtree) for that element to
// be removed, then open - that is waitForOfferToClear.
//
// If no offer is showing yet we cannot tell whether ReCharge has decided
// not to show one or simply hasn't finished syncing, so sequenceOpen races
// three signals and acts on whichever arrives first:
//   1. a MutationObserver on the shadow hosts, firing as soon as the offer
//      element appears;
//   2. ReCharge's own cart:update / cart:refresh pub/sub events
//      (window.RechargePubSub, subscribed once at page load) - these fire
//      once ReCharge has finished syncing to a given add-to-cart, which is
//      its own real signal that it has decided whether to show an offer,
//      not a guessed duration;
//   3. OFFER_DECISION_MS (1500ms) as a guard, so the drawer is never held
//      indefinitely waiting on an offer that will never appear - ReCharge
//      script blocked, app uninstalled, or simply a product with no
//      subscription option.
// Whichever fires first, we re-check the shadow DOM once: if an offer is up,
// hand off to waitForOfferToClear; otherwise open immediately.
//
// waitForOfferToClear has NO time limit of its own - once an offer is
// confirmed visible the drawer waits however long the shopper leaves it
// open. Its 500ms setInterval is only a backstop against a shadow-root
// removal the observers somehow fail to report, and it routes through the
// same settle() guard, so it can never open the drawer under a visible
// offer.
//
// Our own cart drawer is opened by theme.CartDrawer.prototype.open (called
// by the theme's own "ajaxProduct:added"/"cart:open" listeners, which cover
// both the standard PDP add-to-cart form and this file's Quick Buy dialog).
// That method always calls theme.Drawers.prototype.open with a fresh,
// unbound lookup on every call path - see the comment above patchDrawer()
// below for why we patch that method instead of CartDrawer.prototype.open
// directly.
(function () {
  var SHADOW_HOST_IDS = [
    "recharge-storefront-experiences__cart-overlay",
    "recharge-storefront-experiences__cart-drawer",
  ];
  var OFFER_ELEMENT_ID = "cart-overlay-drawer";
  var OFFER_DECISION_MS = 1500;

  function getShadowHosts() {
    return SHADOW_HOST_IDS.map(function (id) {
      return document.getElementById(id);
    }).filter(function (h) {
      return h && h.shadowRoot;
    });
  }

  function findOfferElement() {
    var hosts = getShadowHosts();
    for (var i = 0; i < hosts.length; i++) {
      var el = hosts[i].shadowRoot.querySelector("#" + OFFER_ELEMENT_ID);
      if (el) return el;
    }
    return null;
  }

  function isOfferShowing() {
    return !!findOfferElement();
  }

  var cartSyncWaiters = [];
  function onRechargeCartSync() {
    var waiters = cartSyncWaiters;
    cartSyncWaiters = [];
    waiters.forEach(function (fn) {
      fn();
    });
  }

  function subscribeToRecharge() {
    if (!window.RechargePubSub || typeof window.RechargePubSub.subscribe !== "function") {
      return false;
    }
    if (window.RechargePubSub.__ncSubscribed) return true;
    window.RechargePubSub.subscribe("cart:update", onRechargeCartSync);
    window.RechargePubSub.subscribe("cart:refresh", onRechargeCartSync);
    window.RechargePubSub.__ncSubscribed = true;
    return true;
  }

  function waitForOfferToClear(callback) {
    var hosts = getShadowHosts();
    if (!hosts.length || !isOfferShowing()) {
      callback();
      return;
    }
    var done = false;
    var observers = [];
    var poll = null;
    function settle() {
      if (done || isOfferShowing()) return;
      done = true;
      observers.forEach(function (o) {
        o.disconnect();
      });
      clearInterval(poll);
      callback();
    }
    hosts.forEach(function (host) {
      var observer = new MutationObserver(settle);
      observer.observe(host.shadowRoot, { childList: true, subtree: true });
      observers.push(observer);
    });
    // Backstop only, in case a removal inside the shadow root is somehow
    // not reported by the observers above. It routes through settle(),
    // which returns early while the offer is still showing, so it can
    // never open the drawer underneath a visible offer - however long the
    // shopper leaves that offer open.
    poll = setInterval(settle, 500);
  }

  // Shared sequencing logic used by both patches below.
function sequenceOpen(reallyOpen){
if(isOfferShowing()){waitForOfferToClear(reallyOpen);return}
var settled=!1,observers=[],guard=null;
function finish(){if(settled)return;settled=!0;clearTimeout(guard);observers.forEach(function(o){o.disconnect()});var i=cartSyncWaiters.indexOf(onSync);i!==-1&&cartSyncWaiters.splice(i,1);isOfferShowing()?waitForOfferToClear(reallyOpen):reallyOpen()}
function onSync(){finish()}
getShadowHosts().forEach(function(host){var o=new MutationObserver(function(){isOfferShowing()&&finish()});o.observe(host.shadowRoot,{childList:!0,subtree:!0});observers.push(o)});
subscribeToRecharge()&&cartSyncWaiters.push(onSync);
guard=setTimeout(finish,OFFER_DECISION_MS)}

  // Subscribe as early as possible (independent of any particular
  // add-to-cart) so we don't miss the sync event for the very first add.
  // Recharge's script defines window.RechargePubSub asynchronously, so -
  // same as the theme.Drawers/theme.CartDrawer polling below - this polls
  // briefly until it exists rather than assuming it's there yet.
  if (!subscribeToRecharge()) {
    var rechargePollAttempts = 0;
    var rechargePollMax = 200; // 200 * 100ms = 20s
    var rechargePoll = setInterval(function () {
      rechargePollAttempts++;
      if (subscribeToRecharge() || rechargePollAttempts >= rechargePollMax) {
        clearInterval(rechargePoll);
      }
    }, 100);
  }

  // Returns true once patched (or already patched), false if theme.CartDrawer
  // isn't defined yet.
  function patchCartDrawer() {
    if (!window.theme || !theme.CartDrawer || !theme.CartDrawer.prototype) {
      return false;
    }
    if (theme.CartDrawer.prototype.__ncSequencedOpen) {
      return true;
    }
    var originalOpen = theme.CartDrawer.prototype.open;
    theme.CartDrawer.prototype.open = function () {
      var self = this;
      var args = arguments;
      sequenceOpen(function () {
        originalOpen.apply(self, args);
      });
    };
    theme.CartDrawer.prototype.__ncSequencedOpen = true;
    return true;
  }

  // REAL ROOT CAUSE, found Aug 16 via live instrumentation on the actual PDP
  // "Add to cart" button: theme.js's theme.CartDrawer.init() runs once, at
  // construction time (page load), and does:
  //   document.addEventListener("cart:open", this.open.bind(this))
  // `.bind()` permanently snapshots whatever `CartDrawer.prototype.open` was
  // AT THAT EXACT MOMENT - the ORIGINAL, unpatched method, since init() runs
  // before this file's patch ever gets a chance to run. Patching
  // `CartDrawer.prototype.open` afterward (patchCartDrawer(), above) has NO
  // effect on that already-bound "cart:open" listener. Confirmed live: a real
  // click on the PDP's native "Add to cart" button goes through that
  // pre-bound "cart:open" path and completely bypassed patchCartDrawer(),
  // while only this file's own Quick Buy dialog (which dispatches
  // "ajaxProduct:added", picked up via a *fresh*, unbound `this.open()`
  // lookup each time) would have seen it - explaining why the patch verified
  // as "installed" (`theme.CartDrawer.prototype.__ncSequencedOpen === true`)
  // but the real add-to-cart flow never actually waited.
  //
  // theme.CartDrawer.prototype.open, in turn, always calls `this.drawer.open()`
  // - a *fresh*, unbound lookup against `theme.Drawers.prototype` every time,
  // on every call path, including the pre-bound "cart:open" listener. Patching
  // `theme.Drawers.prototype.open` instead - scoped to only the cart drawer
  // instance via `this.config.id === "CartDrawer"` (theme.Drawers is shared by
  // every slide-out drawer on the site: mobile nav, filters, etc., and we must
  // not delay those) - is the one layer every invocation path converges on,
  // confirmed live via instrumented testing of a real add-to-cart.
  function patchDrawer() {
    if (!window.theme || !theme.Drawers || !theme.Drawers.prototype) {
      return false;
    }
    if (theme.Drawers.prototype.__ncSequencedOpen) {
      return true;
    }
    var originalDrawerOpen = theme.Drawers.prototype.open;
    theme.Drawers.prototype.open = function (evt, returnFocusEl) {
      var self = this;
      var args = arguments;
      if (!this.config || this.config.id !== "CartDrawer") {
        return originalDrawerOpen.apply(self, args);
      }
      sequenceOpen(function () {
        originalDrawerOpen.apply(self, args);
      });
    };
    theme.Drawers.prototype.__ncSequencedOpen = true;
    return true;
  }

  function patchAll() {
    // Use non-short-circuiting & so both patches are always attempted, even
    // if theme.CartDrawer exists before theme.Drawers does or vice versa.
    var a = patchCartDrawer();
    var b = patchDrawer();
    return a && b;
  }

  // FIX (Aug 16, confirmed live): both scripts load with `defer`, so custom.js
  // runs before DOMContentLoaded fires - but theme.js does NOT assign
  // `theme.CartDrawer`/`theme.Drawers` synchronously at top-level; they're
  // only defined by the time some later, unspecified init step runs. Trying
  // once immediately and once on DOMContentLoaded isn't reliable - on the
  // real live site, neither was defined yet at either of those moments, so
  // the patch silently never installed. Falls back to polling every 250ms
  // (up to 20s) until both exist, so the patch installs no matter when the
  // theme defines them - this is the same "wait for it to exist" pattern
  // already used elsewhere in this file/product-template.liquid for waiting
  // on ReCharge's purchase-option radios.
  if (!patchAll()) {
    document.addEventListener("DOMContentLoaded", function () {
      if (patchAll()) return;
      var pollAttempts = 0;
      var maxPollAttempts = 80; // 80 * 250ms = 20s
      var pollInterval = setInterval(function () {
        pollAttempts++;
        if (patchAll() || pollAttempts >= maxPollAttempts) {
          clearInterval(pollInterval);
        }
      }, 250);
    });
  }
})();

// Sticky mobile add-to-cart bar (Sept 2026, Round 9).
//
// The mobile audit found Add to Cart sitting ~1.7 screens down the PDP even
// after Round 8's image trims (y=1,343 on an 812px viewport). The buy box
// stacks title, price, roast, tasting notes, variant picker, quantity and
// purchase frequency above the button and none of that can be cut, so the
// remedy is to keep the CTA reachable rather than to shorten the stack.
//
// The bar is built here rather than in Liquid deliberately: it is a pure
// progressive enhancement over markup the theme already renders, so building
// it in JS keeps the whole feature in two files (here and the matching block
// in assets/custom.css) and leaves snippets/product-template.liquid - the
// single most heavily customised file in this theme - untouched.
//
// It owns no cart logic. Its button calls .click() on the real
// [data-add-to-cart] submit button inside the product form, so the theme's own
// submit handler runs untouched and everything downstream of it - variant and
// selling-plan selection, quantity, the ReCharge purchase-option radios, the
// cart-drawer sequencing patched just above - behaves exactly as it does when
// the shopper presses the real button. Verified live on Full Cycle: switching
// the size to 2lbs and picking Subscribe & Save, then pressing the bar's
// button, added "Full Cycle - 2lbs / Whole Bean" on the "Delivery every 1
// week" plan at the subscription price.
//
// Price and label are mirrored, not recomputed: a MutationObserver watches the
// PDP's whole price block and the real add-to-cart button, so the
// price-crossout script at the end of product-template.liquid, the theme's own
// variant-change handler and ReCharge all keep the bar in sync without this
// code knowing anything about them.
//
// Visibility rules, all four required:
//   1. the real add-to-cart button is actually rendered. This is the B2B
//      guard: SparkLayer hides the whole buy box for signed-in wholesale
//      customers (every block in it carries data-spark="b2c-only"), and an
//      element inside a display:none ancestor reports offsetParent === null
//      whatever mechanism hid it, so the bar stays down for them without this
//      code needing to know anything about SparkLayer;
//   2. the shopper has scrolled past REVEAL_AFTER_PX, so the bar never covers
//      the top of the page on load;
//   3. the real add-to-cart button is not currently in the viewport, so the
//      shopper is never shown two add-to-cart buttons at once;
//   4. the page is not scrolled to within FOOTER_GUARD_PX of the bottom, so
//      the bar releases the last of the footer instead of sitting on it.
//
// Styling is mobile-only - assets/custom.css hides .sticky-atc at every width
// and only its <=768px block can show it - so there is no width at which a
// desktop shopper sees this.
(function () {
  var REVEAL_AFTER_PX = 400;
  var FOOTER_GUARD_PX = 140;

  function init() {
    // Product page only. Not the quick-view modal, not a featured-product
    // section on another template - both of which also render .product-section.
    if (!document.body.classList.contains("template-product")) return;

    var section = document.querySelector('.product-section[data-history="true"]');
    if (!section) return;

    var realBtn = section.querySelector("form.product-single__form [data-add-to-cart]");
    if (!realBtn) return;

    var realLabel = section.querySelector("[data-add-to-cart-text]");
    var realPrice = section.querySelector("[data-product-price]");
    var priceBlock = section.querySelector(".product-block--price");

    var bar = document.createElement("div");
    bar.className = "sticky-atc";
    // Matches every other buy-box block in product-template.liquid, so
    // SparkLayer treats this the same way if it scans the DOM after load.
    // Rule 1 above is the guard that does not depend on that happening.
    bar.setAttribute("data-spark", "b2c-only");

    var info = document.createElement("div");
    info.className = "sticky-atc__info";

    var titleEl = document.createElement("span");
    titleEl.className = "sticky-atc__title";
    titleEl.textContent = section.getAttribute("data-product-title") || "";

    var priceEl = document.createElement("span");
    priceEl.className = "sticky-atc__price";

    info.appendChild(titleEl);
    info.appendChild(priceEl);

    var barBtn = document.createElement("button");
    barBtn.type = "button";
    barBtn.className = "btn sticky-atc__btn";

    bar.appendChild(info);
    bar.appendChild(barBtn);
    document.body.appendChild(bar);

    var atcInViewport = false;
    var lastCurrent = null;
    var lastCompare = null;

    function realButtonRendered() {
      return !!realBtn.offsetParent;
    }

    function syncButton() {
      var label = realLabel ? realLabel.textContent.trim() : "";
      if (label && barBtn.textContent !== label) {
        barBtn.textContent = label;
      }
      barBtn.disabled = !!realBtn.disabled;
    }

    // The compare-at ("was") price has to be looked up on every sync rather
    // than captured once at init. The theme only renders [data-compare-price]
    // in the initial markup when the product is on sale, and the price-crossout
    // script at the end of product-template.liquid CREATES one on the fly when
    // the shopper picks a subscription frequency - confirmed live on Full
    // Cycle, where choosing Subscribe & Save inserts a $46.00 crossout beside
    // the $36.80 subscription price with no [data-product-price-wrap] present
    // at all. Capturing at init missed that case and the bar showed only the
    // discounted figure with nothing to compare it against.
    function currentCompare() {
      var cmp = section.querySelector("[data-compare-price]");
      if (!cmp) return "";
      var wrap = section.querySelector("[data-product-price-wrap]");
      if (wrap && wrap.classList.contains("hide")) return "";
      return cmp.textContent.trim();
    }

    function syncPrice() {
      if (!realPrice) return;
      var current = realPrice.textContent.trim();
      var compare = currentCompare();
      if (current === lastCurrent && compare === lastCompare) return;
      lastCurrent = current;
      lastCompare = compare;

      priceEl.textContent = "";
      if (compare && compare !== current) {
        var was = document.createElement("span");
        was.className = "sticky-atc__price--compare";
        was.textContent = compare;
        priceEl.appendChild(was);
      }
      priceEl.appendChild(document.createTextNode(current));
    }

    function atBottomOfPage() {
      return (
        window.pageYOffset + window.innerHeight >=
        document.documentElement.scrollHeight - FOOTER_GUARD_PX
      );
    }

    function updateVisibility() {
      var show =
        realButtonRendered() &&
        window.pageYOffset > REVEAL_AFTER_PX &&
        !atcInViewport &&
        !atBottomOfPage();
      bar.classList.toggle("sticky-atc--visible", show);
    }

    barBtn.addEventListener("click", function () {
      if (realBtn.disabled) return;
      realBtn.click();
    });

    var hasIO = "IntersectionObserver" in window;
    if (hasIO) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          atcInViewport = entry.isIntersecting;
        });
        updateVisibility();
      }).observe(realBtn);
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        if (!hasIO) {
          var r = realBtn.getBoundingClientRect();
          atcInViewport = r.bottom > 0 && r.top < window.innerHeight;
        }
        updateVisibility();
      });
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    var mirrorOptions = {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "disabled"],
    };
    var mirrorObserver = new MutationObserver(function () {
      syncButton();
      syncPrice();
      updateVisibility();
    });
    mirrorObserver.observe(realBtn, mirrorOptions);
    // Watch the whole price block, not just [data-product-price] - the compare
    // element can be inserted into it after load (see currentCompare above).
    if (priceBlock) {
      mirrorObserver.observe(priceBlock, mirrorOptions);
    } else if (realPrice) {
      mirrorObserver.observe(realPrice, mirrorOptions);
    }

    syncButton();
    syncPrice();
    updateVisibility();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
